const StyleAuxiliary = props => (
	<div className={props.classes}>{props.children}</div>
);

export default StyleAuxiliary;
